import React , { useEffect, useState } from 'react';

// Import Style
import './Testimonial.scss';

import NulogyPaulSatkunasingam from './img/nulogy-paul-satkunasingam.jpg';
import Nulogy from './img/nulogy.png';

import CeciFernandes from './img/ceci-fernandes.png';
import Nu from './img/nu.svg';

import DoodleJensNaie from './img/doodle-jens-naie.jpg';
import Doodle from './img/doodle.svg';

import EduardoPinzon from './img/eduardo-pinzon.jpg';
import Syngenta from './img/syngenta.png';

import ReinaldoSimizy from './img/Reinaldo-Simizu.jpg';
import Matera from './img/matera.svg';

import BrendanWovchko from './img/Brendan-Wovchko.jpg';
import DaveRamsey from './img/dave-ramsey.svg';

import JohnGuzman from './img/John-Guzman.jpg';
import FrostDesign from './img/FrostDesign.svg';

import FrancineSouza from './img/FrancineSouza.jpg';
import ArcTouch from './img/ArcTocuh-Logo.svg';

import PetriPienaar from './img/PetriPienaar.jpg';
import HEBStratAgi from './img/HEBStratAgi.jpg';

import EricJanKaak from './img/EricJanKaak.jpg';
import SPARICS from './img/SPARICS.png';

import ZoranVujkov from './img/Zoran-Vujkov.png';
import UnitedCloud from './img/united-cloud.svg';

import DiegoRossiniVieira from './img/DiegoRossiniVieira.jpg';
import Nubank from './img/nu.svg';

import LaszloTorok from './img/LaszloTorok.jpg';
//import Nubank from './img/nu.svg';

import PawelLewinski from './img/PawelLewinski.png';
import AgileLabs from './img/logo-agilelab.png';

import BethGarwood from './img/Brendan-Wovchko.jpg'; //no
import Altr from './img/altr-logo.png';

import DanielOcampo from './img/DanielOcampo.jpg';
import Holcim from './img/Holcim.png';

import BillMeireles from './img/BillMeireles.jpg';
import Afya from './img/Afya.jpg';

import VadymPospielov from './img/VadymPospielov.png'; //no
import Uklon from './img/Uklon.svg';

import ChrisWare from './img/ChrisWare.jpg';
import EconomistGroup from './img/economistgroup.svg';

import GerhardWagler from './img/GerhardWagler.jpg';
import Beyonnex from './img/Beyonnex.svg';

import MarioViktorov from './img/MarioViktorov.jpg';
import Contentsquare from './img/Contentsquare.svg';

import AlexanderPopov from './img/AlexanderPopov.jpg';
import OfficeRnD from './img/officernd.svg';

import ThiagoFerreira from './img/ThiagoFerreira.jpg';
import Yape from './img/yape.png';

import AmandaVarella from './img/AmandaVarella.jpg';
//import Yape from './img/yape.png'; ?

function Testimonial() {
    const list = [
      { 
        id: 1, 
        image: NulogyPaulSatkunasingam,
        title: "Nulogy uses Nave to create company-wide alignment around performance metrics", 
        description: "Data without a story is just numbers. It is all about connecting different departments through data. For example, capturing adoption metrics and linking them back to sales or marketing targets - that is what drives the business forward.",
        name: "Paul Satkunasingam",
        position: "Software Development Manager",
        companyLogo: Nulogy,
      },
      { 
        id: 2, 
        image: CeciFernandes,
        title: "Nubank's global productivity team unlocks superior productivity at scale with Nave", 
        description: "One of our values at Nubank is building strong and diverse teams - and diverse teams work best in very different ways. Nave works great with that. Even teams that have very different workflows, practices and organizations can get useful insight from Nave.",
        name: "Ceci Fernandes",
        position: "Global Productivity Leader",
        companyLogo: Nu,
      },
      { 
        id: 3, 
        image: DoodleJensNaie,
        title: "Doodle transitions from story point estimates to no estimates with Nave in less than 6 months", 
        description: "Switching from estimates to probabilistic forecasting was a game-changer! Using statistics instead of fixed dates allowed everyone to work more relaxed and focus on quality.",
        name: "Jens Naie",
        position: 'CTO',
        companyLogo: Doodle,
      },
      { 
        id: 4, 
        image: EduardoPinzon,
        title: "Syngenta Digital uses Nave to purge 67% of issues from their backlog", 
        description: "I am able to forecast delivery dates using our past performance data. I just look at the chart and see that in 85% of cases, we fixed critical-priority bugs in less than 3 days! When a new high-priority bug comes up, we now know how to answer our client biggest question: When will it be done?",
        name: "Eduardo Pinzon",
        position: "Delivery Manager at Syngenta Digital",
        companyLogo: Syngenta,
      },
      { 
        id: 5, 
        image: ReinaldoSimizy,
        title: "Matera cuts lead times by 4x despite losing a team member", 
        description: "We had a developer leave the team right in the middle of a huge project. The typical behavior in this situation would be to bring another developer on board, but instead, we simply kept managing the flow and checking Nave, only to find out that we were having almost the same delivery cadence.",
        name: "Reinaldo Simizy",
        position: "Agile Coach",
        companyLogo: Matera,
      },
      { 
        id: 6, 
        image: BrendanWovchko,
        title: "Ramsey Solutions manage their workflows using Nave to achieve over 60% flow efficiency", 
        description: "Before Nave, if you had said to me 'Hey, how are your 60 teams doing?' you'd get different answers depending on who you talked to, and we didn't have any data to prove anything. Now, we can show that a team needs more QA people, based on looking at the data. Those are real, tangible benefits that we've been able to see.",
        name: "Brendan Wovchko",
        position: "CTO at Ramsey Solutions",
        companyLogo: DaveRamsey,
      },
      { 
        id: 7, 
        image: JohnGuzman,
        title: "Design Agency Hits Deadlines 95% Of the Time Using Continuous Forecasting", 
        description: "I don't think I'm ever going back to any of my previous practices. It transformed us into an organization that looks at metrics that matter, and that can tell where things need improving.",
        name: "John Paul de Guzman",
        position: "Founder of Frost Design and Consulting Group",
        companyLogo: FrostDesign
      },
      { 
        id: 8, 
        image: FrancineSouza,
        title: "ArcTouch Reduces Ticket Reopen Rate by 5x with Nave", 
        description: "In just a few months, we managed to reduce the time tickets spent in the QA phase, and the lines on the Cumulative Flow Diagram increased consistently, as expected.",
        name: "Francine Souza",
        position: "Agile Project Manager at ArcTouch",
        companyLogo: ArcTouch
      },
      { 
        id: 9, 
        image: PetriPienaar,
        title: "Large Financial Institution Reduces Cycle Time by 67% in Just 5 Months with Nave", 
        description: "What was amazing about this team is, they went through this huge clean up exercise and they were still able to cut down on their delivery times. They were able to do it by focusing on finishing work instead of starting new work. That to me was the biggest success!",
        name: "Petri Pienaar",
        position: "Business Agility and Flow Coach",
        companyLogo: HEBStratAgi
      },
      { 
        id: 10, 
        image: EricJanKaak,
        title: "Achieving 37% Improvement in Throughput in Less Than 5 Months with Nave",
        description: "When teams looked at their recent performance, they realized that if they had worked that way in the past year, they could have had 12 extra weeks of vacation without compromising their productivity! When you show people those numbers, their eyes go wide open.",
        name: "Eric-Jan Kaak",
        position: "Flow Master at SPAR ICS",
        companyLogo: SPARICS
      },
      { 
        id: 11, 
        image:  ZoranVujkov,
        title: "United Cloud Teams Sustain Efficient Operations at Scale with Nave",
        description: "When they say, 'We are doing great,' and I show them the charts and illustrate how much more efficient we could be, it's truly eye-opening!",
        name: "Zoran Vujkov",
        position: "Agile Coach at United Cloud",
        companyLogo: UnitedCloud
      },
      { 
        id: 12, 
        image: DiegoRossiniVieira,
        title: "Nubank Uses Nave's Actionable Insights to Drive Continuous Improvement",
        description: "By furnishing detailed metrics, Nave empowers every team member to make informed decisions based on evidence rather than guesswork. This shift in approach enhances the team's maturity, transitioning from speculation to evidence-based practices.",
        name: "Diego Rossini Vieira",
        position: "Senior Engineering Manager at Nubank",
        companyLogo: Nubank
      },
      { 
        id: 13, 
        image: LaszloTorok,
        title: "Managers at Nubank Rely on Nave to Streamline Knowledge Work",
        description: "Nave allows us to get actionable insights about our work and organizational performance in a way that none of the other tools, including the ones built into our project management system offer.",
        name: "Laszlo Török",
        position: "Data Infrastructure Lead at Nubank",
        companyLogo: Nubank
      },
      { 
        id: 14, 
        image: PawelLewinski,
        title: "This Kanban Team Managed to Improve Their Delivery Times by 30% (in Less Than a Month!)",
        description: "Before Nave, the daily stand ups were like, 'Okay, I'm working on a, b, c,' and everyone was just syncing on what they were individually doing. No one was looking at the whole picture or the team's progress. Right now, we as a team are focused on moving the work forward.",
        name: "Pawel Lewinski",
        position: "Accredited Kanban Trainer",
        companyLogo: AgileLabs
      },
      { 
        id: 15,
        title: "A Smarter Approach to Workflow Management with Nave",
        description: "Nave has been integral in understanding our workflow and identifying areas for improvement. It's easy to set up and the charts/metrics are presented in an easy-to-understand manner. The Nave team is also incredibly responsive and helpful.",
        name: "Beth Garwood",
        position: "Director of Program Management | ALTR",
        companyLogo: Altr
      },
      { 
        id: 16, 
        image: DanielOcampo,
        title: "A Fresh Look and Smarter Insights for Kanban Teams",
        description: "Nave is a great tool to understand your team workflow. I love the new look and feel. The new 'process improvement dashboard' is very useful and easy to read.",
        name: "Daniel Ocampo",
        position: "Agile coach at LafargeHolcim Americas Digital Center",
        companyLogo: Holcim
      },
      { 
        id: 17, 
        image: BillMeireles,
        title: "Empowering Modern Management with Actionable Insights",
        description: "It is an intelligent tool to modern management. It is powerfull because there is many knowledge of wise people behind the default dashboards. The tool offers a complete tracking of datas and this way you can understand your context quickly.",
        name: "Bill Meireles",
        position: "Agile coach at Afya",
        companyLogo: Afya
      },
      { 
        id: 18, 
        image: VadymPospielov,
        title: "The Go-To Tool for Managers Seeking Efficiency",
        description: "Nave is the one of the must-have tools for managers using the Kanban framework to easily find and analyze bottlenecks in the system.",
        name: "Vadym Pospielov",
        position: "VP of Engineering at Uklon",
        companyLogo: Uklon
      },
      { 
        id: 19, 
        image: ChrisWare,
        title: "Seamless Jira Integration with Kanban Metrics & Forecasting",
        description: "Nave has really helped augment JIra with Kanban metrics and forecasting tooling, with dashboards and charts catering for individual team and exec-level reporting. Great customer support and frequent feature updates. Intuitive, easy to set up and provides immediate benefit with insights and workflow improvement suggestions. Thank you!",
        name: "Chris Ware",
        position: "VP Delivery - Economist Digital",
        companyLogo: EconomistGroup
      },
      { 
        id: 20, 
        image: GerhardWagler,
        title: "The Must Have Kanban Analytics Tool for JIRA Teams",
        description: "In my eyes THE go-to tool for Kanban metrics, if you have to use JIRA. The configuration is easy, the teams can use it on their own, and the effects were visible within a few weeks. Plus: Great reaction times for support issues.",
        name: "Gerhard Wagler",
        position: "Agile Lead at Beyonnex.io",
        companyLogo: Beyonnex
      },
      { 
        id: 21, 
        image: MarioViktorov,
        title: "A Versatile Kanban Tool That Adapts to Every Team and Organization",
        description: "I've been using Nave in multiple roles and companies. In every one of them, it has helped teams observe, understand and improve the way they work together. Its flexibility allows you to build and monitor at a department or company level. Working without a tool of these characteristics would be like flying blind.",
        name: "Mario Viktorov",
        position: "Sr. Engineering Manager at Contentsquare",
        companyLogo: Contentsquare
      },
      { 
        id: 22, 
        image: AlexanderPopov,
        title: "A Reliable Solution for Planning & Forecasting",
        description: "Nave helped us find and solve inefficiencies in our Kanban system, which led to more stable and predictable cycle times. We constantly use it to provide reliable estimations how much work the team can do in a given period or when a set of work items will be delivered. Nave really is an integral part of our planning and operations processes.",
        name: "Alexander Popov",
        position: "Senior Software Engineering Manager at OfficeRnD",
        companyLogo: OfficeRnD
      },
      { 
        id: 23, 
        image: ThiagoFerreira,
        title: "Exceptional Customer Support That Makes a Difference",
        description: "Nave is a tool that has become essential for our organization, helping to extract very important information regarding our teams efficiency. The usability, visuals and accuracy of the information are excellent and the tool is constantly evolving, with new features and resources being launched and improved.",
        name: "Thiago Ferreira",
        position: "Agile Engineering Manager at Yape",
        companyLogo: Yape
      },
      { 
        id: 24, 
        image: AmandaVarella,
        title: "Nave Came to Fill a Gap in the Kanban Way",
        description: "For years I've been looking for an easy way to gather delivery metrics. It always involved scripting, spreadsheets, and cumbersome processes. When I started using Nave I felt that I finally found what I was looking for. A tool easy to use, with real-time sync and great interface, which is helping me save a lot of time.",
        name: "Amanda Varella",
        position: "Kanban Coach and Trainer",
      }
    ];

    const [randomData, setRandomData] = useState(() => list.sort(() => .5 - Math.random()));
    
    const listItems = randomData && randomData.map((item, index) =>
      <div key={index} className={'testimonial testimonial-' + (index + 1)}>
        {item.image && 
          <div className='testimonial_image'>
            <img src={item.image} alt="" />
          </div>
        }
        <div className='testimonial_info'>
          <h4>{item.title}</h4>
          <p>“{item.description}”</p>
          <div className='testimonial_company-info'>
            <div>
              <p className='name'>{item.name}</p>
              <p className='position'>{item.position}</p>
            </div>
            {item.companyLogo && 
              <div className='company-logo'>
                <img src={item.companyLogo} alt="" />
              </div>
            }
          </div>
        </div>
      </div>
    );
    return (
      <div className='testimonial-slideshow'>
      {listItems}
      </div>
    );
  
}

export default Testimonial;